import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "../locales/en/translation.json";
import esTranslation from "../locales/ar/translation.json";
import { applyDocumentDirection } from "../helper/documentDirection";


// Get saved language from localStorage or default to "en"
const getSavedLanguage = (): string => {
  const savedLang = localStorage.getItem("i18nextLng");
  return savedLang && (savedLang === "en" || savedLang === "ar")
    ? savedLang
    : "en";
};

// Initialize i18next
// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      ar: {
        translation: esTranslation,
      },
    },
    lng: getSavedLanguage(),
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    detection: {
      // Order of detection methods
      order: ["localStorage", "navigator"],
      // Keys to lookup language from
      lookupLocalStorage: "i18nextLng",
      // Cache user language
      caches: ["localStorage"],
    },
  });

const initialLang = getSavedLanguage();
applyDocumentDirection(initialLang);

export default i18next;
